import { Box, Card, Stack, Typography } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import React from "react";
import PropTypes from "prop-types";
import { AnimationOnScroll } from "react-animation-on-scroll";

const ModuleCard = ({ icon, title, description, link, avaliable = false }) => {
   return (
      <Card
         py={2}
         sx={{
            width: { xs: "60vw", sm: "40vw", md: "35vw", lg: "250px" },
            border: "1.5px solid #3D8FD6",
            boxShadow: "0 0 14px 1px #5AAAE8",
            borderRadius: "10px",
            my: 3,
            mx: 0.5,
         }}
      >
         <Stack direction={"column"} spacing={2} alignItems={"center"} py={3}>
            <AnimationOnScroll
               animateIn="animate__bounceIn"
               animateOnce
               animatePreScroll={false}
               duration={0.75}
               delay={50}
            >
               <Box
                  sx={{
                     width: "150px",
                     height: "125px",
                     backgroundImage: icon,
                     backgroundRepeat: "no-repeat",
                     backgroundPosition: "center center",
                  }}
               />
            </AnimationOnScroll>
            <Typography
               fontFamily={"Extrabold"}
               fontSize={"15px"}
               sx={{ textAlign: "center", lineHeight: 1, color: avaliable ? "#4778A5" : "#162C44" }}
            >
               {title}
            </Typography>
            <Typography
               px={3}
               textAlign={"justify"}
               color={"#5D6D7C"}
               height={"100px"}
               overflow={"hidden"}
               lineHeight={1.1}
               fontSize={"15px"}
            >
               {description}
            </Typography>
            {avaliable ? (
               <Link to={link} target="_blank" style={{ textDecoration: "none" }}>
                  <Typography
                     overflow={"hidden"}
                     sx={{
                        fontSize: { xs: "15px", md: "auto" },
                        color: "#7ACCC2",
                        "&:hover": { color: "#5EBEB3" },
                     }}
                  >
                     <strong>Conozca más...</strong>
                  </Typography>
               </Link>
            ) : (
               <Link
                  to={link}
                  style={{ textDecoration: "none" }}
                  target="_blank"
                  onClick={() => {
                     const sectionSelector = link.split("#");
                     localStorage.setItem("selectedService", sectionSelector[1]);
                  }}
               >
                  <Typography
                     sx={{
                        fontSize: { xs: "15px", md: "auto" },
                        color: "#FF4F5B",
                        "&:hover": { color: "#e0434e" },
                     }}
                  >
                     <strong>Próximamente...</strong>
                  </Typography>
               </Link>
            )}
         </Stack>
      </Card>
   );
};

ModuleCard.propTypes = {
   icon: PropTypes.string,
   title: PropTypes.string,
   description: PropTypes.string,
   link: PropTypes.string,
   avaliable: PropTypes.bool,
};

export default ModuleCard;
